// extracted by mini-css-extract-plugin
export default {"card":"DeliveryTimeline_card__Ev2KK","title":"DeliveryTimeline_title__gr9YZ","sub":"DeliveryTimeline_sub__dti3s","when":"DeliveryTimeline_when__f0qFJ"};